var uris = [
  [1, require("/opt/buildhome/repo/js/login/firstscreen/storyCarouselCards/img/trustStoryDeckViewAvatars/xx888.png?asset")],
  [2, require("/opt/buildhome/repo/js/login/firstscreen/storyCarouselCards/img/trustStoryDeckViewAvatars/xx888@2x.png?asset")],
  [3, require("/opt/buildhome/repo/js/login/firstscreen/storyCarouselCards/img/trustStoryDeckViewAvatars/xx888@3x.png?asset")]
];

module.exports = {
  get uri() {
    var ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    for (var i = 0; i < uris.length; i++) {
      if (uris[i][0] >= ratio) return uris[i][1];
    }
    return uris[uris.length - 1][1];
  },
  width: 42,
  height: 42,
  toString: function () {
    return this.uri;
  },
};
